// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__-+7IQ","spin":"loading_spin__OW+R2","container":"loading_container__bPVzT","fadeIn":"loading_fadeIn__-0Lgk"};